var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { getBpmnId } from '../getBpmnId';
export var getEndEventModel = function (CircleNodeModel) {
    var EndEventModel = /** @class */ (function (_super) {
        __extends(EndEventModel, _super);
        function EndEventModel(data, graphModel) {
            var _this = this;
            if (!data.id) {
                data.id = "Event_" + getBpmnId();
            }
            if (data.text && typeof data.text === 'string') {
                data.text = {
                    value: data.text,
                    x: data.x,
                    y: data.y + 35,
                };
            }
            _this = _super.call(this, data, graphModel) || this;
            return _this;
        }
        EndEventModel.prototype.getConnectedSourceRules = function () {
            var rules = _super.prototype.getConnectedSourceRules.call(this);
            var notAsSource = {
                message: '结束节点不能作为连线的起点',
                validate: function () { return false; },
            };
            rules.push(notAsSource);
            return rules;
        };
        EndEventModel.extendKey = 'EndEventModel';
        return EndEventModel;
    }(CircleNodeModel));
    return EndEventModel;
};
export var getEndEventView = function (CircleNode, h) {
    var EndEventNode = /** @class */ (function (_super) {
        __extends(EndEventNode, _super);
        function EndEventNode() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EndEventNode.prototype.getShape = function () {
            var _a = this.getAttributes(), x = _a.x, y = _a.y, fill = _a.fill, stroke = _a.stroke, strokeWidth = _a.strokeWidth, r = _a.r;
            var outCircle = _super.prototype.getShape.call(this);
            return h('g', {}, outCircle, h('circle', {
                cx: x,
                cy: y,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                r: r - 5,
            }));
        };
        return EndEventNode;
    }(CircleNode));
    return EndEventNode;
};
